import { Singleton } from '@core/decorators/Singleton.decorator';

@Singleton
class EnvironmentService {
  public get baseUrl() {
    return process.env.BASE_URL;
  }

  public get useOktaLogin() {
    return process.env.USE_OKTA_LOGIN;
  }

  public get useMicrosoftLogin() {
    return process.env.USE_MICROSOFT_LOGIN;
  }

  public get azureDirectoryTenantId() {
    return process.env.AZURE_DIRECTORY_TENANT_ID;
  }

  public get azureApplicationClientId() {
    return process.env.AZURE_APPLICATION_CLIENT_ID;
  }

  public get azureScopeId() {
    return process.env.AZURE_SCOPE_ID;
  }
}

const environmentService = new EnvironmentService();

export { environmentService };
